import { HTMLButtonProps } from 'interfaces'
import React from 'react'

import { style, tx } from '@twind/core'

export const buttonStyle = style({
  base: 'inline-flex transition-colors items-center justify-center px-4 py-2 border border-transparent font-medium shadow-sm text-white focus:outline-none not-disabled:focus:ring-2 cursor-pointer disabled:cursor-default disabled:opacity-80 gap-1',
  label: 'button',
  props: {
    variant: {
      primary: 'bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500',
      secondary:
        'text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:ring-indigo-500',
      danger: 'bg-red-600 hover:bg-red-700 focus:ring-red-500',
      warning: 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500',
      success: 'bg-green-600 hover:bg-green-700 focus:ring-green-500',
      transparent:
        'text-zinc-300 hover:bg-zinc-700 hover:text-white shadow-none',
      ghost: 'hover:bg-zinc-700 hover:text-zinc-100',
      link: 'text-primary underline-offset-4 hover:underline',
      outline: 'border border-gray-400 shadow-sm hover:bg-zinc-700 text-white'
    },
    size: {
      small: 'text-xs',
      regular: 'text-base',
      large: 'text-xl',
      icon: 'h-9 w-9'
    },
    rounded: {
      none: 'rounded-none',
      small: 'rounded-sm',
      default: 'rounded-md',
      full: 'rounded-full'
    }
  },
  defaults: {
    variant: 'primary',
    size: 'regular',
    rounded: 'default'
  }
})

export type ButtonStyleProps = (typeof buttonStyle)['defaults']
export type ButtonProps = HTMLButtonProps & ButtonStyleProps

export const Button = (props: ButtonProps) => {
  const {
    variant = 'primary',
    size = 'regular',
    rounded = 'default',
    children,
    className,
    disabled,
    ...rest
  } = props

  return (
    <button
      className={`${tx(
        buttonStyle({ size, variant, rounded }),
        disabled && 'opacity-80 cursor-not-allowed'
      )} ${className} `}
      {...rest}>
      {children}
    </button>
  )
}

export default Button
